"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.iconColors = exports.ComponentWithI18n = void 0;
var react_1 = __importDefault(require("react"));
var useI18n_1 = __importDefault(require("@paprika/l10n/lib/useI18n"));
var tokens_1 = __importDefault(require("@paprika/tokens"));
var Academy_1 = __importDefault(require("@acl-services/wasabicons/lib/Academy"));
var AssetTypes_1 = __importDefault(require("@acl-services/wasabicons/lib/AssetTypes"));
var ClockPlus_1 = __importDefault(require("@acl-services/wasabicons/lib/ClockPlus"));
var ChartArrow_1 = __importDefault(require("@acl-services/wasabicons/lib/ChartArrow"));
var Clipboard_1 = __importDefault(require("@acl-services/wasabicons/lib/Clipboard"));
var CommunityLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/CommunityLogo"));
var FileAdd_1 = __importDefault(require("@acl-services/wasabicons/lib/FileAdd"));
var Flowchart_1 = __importDefault(require("@acl-services/wasabicons/lib/Flowchart"));
var LaunchpadLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/LaunchpadLogo"));
var MissionControl_1 = __importDefault(require("@acl-services/wasabicons/lib/MissionControl"));
var Notebook_1 = __importDefault(require("@acl-services/wasabicons/lib/Notebook"));
var ProjectsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ProjectsLogo"));
var ReportsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ReportsLogo"));
var ResultsLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/ResultsLogo"));
var Robot_1 = __importDefault(require("@acl-services/wasabicons/lib/Robot"));
var Roles_1 = __importDefault(require("@acl-services/wasabicons/lib/Roles"));
var StrategyLogo_1 = __importDefault(require("@acl-services/wasabicons/lib/StrategyLogo"));
var Target_1 = __importDefault(require("@acl-services/wasabicons/lib/Target"));
var TimeAndDate_1 = __importDefault(require("@acl-services/wasabicons/lib/TimeAndDate"));
var Design_1 = __importDefault(require("@acl-services/wasabicons/lib/Design"));
var BulkImport_1 = __importDefault(require("@acl-services/wasabicons/lib/BulkImport"));
function ComponentWithI18n(Icon, name) {
    var I18n = useI18n_1.default();
    return react_1.default.createElement(Icon, { "aria-label": I18n.t("page_header.icons." + name) });
}
exports.ComponentWithI18n = ComponentWithI18n;
var icons = {
    academy: function () { return ComponentWithI18n(Academy_1.default, 'academy'); },
    asset_inventory: function () { return ComponentWithI18n(AssetTypes_1.default, 'asset_inventory'); },
    assets_and_attributes: function () { return ComponentWithI18n(Roles_1.default, 'assets_and_attributes'); },
    assurance_plans: function () { return ComponentWithI18n(FileAdd_1.default, 'assurance_plans'); },
    bulk_importer: function () { return ComponentWithI18n(BulkImport_1.default, 'bulk_importer'); },
    compliance_maps: function () { return ComponentWithI18n(Clipboard_1.default, 'compliance_maps'); },
    community: function () { return ComponentWithI18n(CommunityLogo_1.default, 'community'); },
    frameworks: function () { return ComponentWithI18n(Flowchart_1.default, 'frameworks'); },
    issue_tracker: function () { return ComponentWithI18n(Notebook_1.default, 'issue_tracker'); },
    launchpad: function () { return ComponentWithI18n(LaunchpadLogo_1.default, 'launchpad'); },
    mission_control: function () { return ComponentWithI18n(MissionControl_1.default, 'mission_control'); },
    projects: function () { return ComponentWithI18n(ProjectsLogo_1.default, 'projects'); },
    reports: function () { return ComponentWithI18n(ReportsLogo_1.default, 'reports'); },
    results: function () { return ComponentWithI18n(ResultsLogo_1.default, 'results'); },
    robots: function () { return ComponentWithI18n(Robot_1.default, 'robots'); },
    scheduler: function () { return ComponentWithI18n(TimeAndDate_1.default, 'scheduler'); },
    storyboard: function () { return ComponentWithI18n(ChartArrow_1.default, 'storyboard'); },
    strategy: function () { return ComponentWithI18n(StrategyLogo_1.default, 'strategy'); },
    task_tracker: function () { return ComponentWithI18n(Target_1.default, 'task_tracker'); },
    time_sheets: function () { return ComponentWithI18n(ClockPlus_1.default, 'time_sheets'); },
    toolkits: function () { return ComponentWithI18n(Design_1.default, 'toolkits'); },
};
var purpleBackgroundIconColor = '#F6F0FA';
exports.iconColors = {
    academy: {
        color: tokens_1.default.textColor.icon,
        backgroundColor: tokens_1.default.color.blackLighten70,
    },
    asset_inventory: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    assets_and_attributes: {
        color: tokens_1.default.color.white,
        backgroundColor: tokens_1.default.color.blackLighten10,
    },
    assurance_plans: {
        color: tokens_1.default.color.green,
        backgroundColor: tokens_1.default.color.greenLighten50,
    },
    bulk_importer: {
        color: tokens_1.default.textColor.icon,
        backgroundColor: tokens_1.default.color.blackLighten70,
    },
    compliance_maps: {
        color: tokens_1.default.color.green,
        backgroundColor: tokens_1.default.color.greenLighten50,
    },
    community: {
        color: tokens_1.default.textColor.icon,
        backgroundColor: tokens_1.default.color.blackLighten70,
    },
    frameworks: {
        color: tokens_1.default.color.green,
        backgroundColor: tokens_1.default.color.greenLighten50,
    },
    issue_tracker: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    launchpad: {
        color: tokens_1.default.textColor.icon,
        backgroundColor: tokens_1.default.color.blackLighten70,
    },
    mission_control: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    projects: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    reports: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    results: {
        color: tokens_1.default.color.blueDarken10,
        backgroundColor: tokens_1.default.color.blueLighten50,
    },
    robots: {
        color: tokens_1.default.color.blueDarken10,
        backgroundColor: tokens_1.default.color.blueLighten50,
    },
    scheduler: {
        color: tokens_1.default.color.green,
        backgroundColor: tokens_1.default.color.greenLighten50,
    },
    storyboard: {
        color: tokens_1.default.color.blueDarken10,
        backgroundColor: tokens_1.default.color.blueLighten50,
    },
    strategy: {
        color: tokens_1.default.color.green,
        backgroundColor: tokens_1.default.color.greenLighten50,
    },
    task_tracker: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    time_sheets: {
        color: tokens_1.default.color.eggplantLighten30,
        backgroundColor: purpleBackgroundIconColor,
    },
    toolkits: {
        color: tokens_1.default.textColor.icon,
        backgroundColor: tokens_1.default.color.blackLighten70,
    },
};
exports.default = icons;
//# sourceMappingURL=constants.js.map